import { render, staticRenderFns } from "./AccordionGroup.vue?vue&type=template&id=c8b65794&"
import script from "./AccordionGroup.vue?vue&type=script&lang=js&"
export * from "./AccordionGroup.vue?vue&type=script&lang=js&"
import style0 from "./AccordionGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports